export default __webpack_public_path__ + "static/media/img7.cf4c5449.jpg";